import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import deviceDOMHoc from '../../hocs/deviceDOMHoc';
import { PushButton } from './components';
import {
  Sound,
  Sounds,
} from '../Sound';
import { OUTPUT_TTL } from '../../constants/Pac';
import { DeviceStatusLabel } from './components/labels';

@inject('batchStore')
@observer
class Tank extends Component {
  render() {
    const { device, batchStore } = this.props;
    const isNonEmpty = batchStore.isInputPortOff(device.emptyStatusPNo);
    const closeStatus = batchStore.isInputPortOff(device.closeStatusPNo);
    const cn = closeStatus ? 'gate-open' : 'gate-close';
    const batchData = batchStore.getDeviceStatus(device.id);
    const status = batchData.status;
    const error = batchData.error ? 'error' : '';
    const mCode = batchData.uid ? `${batchData.tId || batchData.uid} ${batchData.currentDrop}/${batchData.allDrops}` : '';
    const progress = isNonEmpty ? 100 : 0;
    const name = device.description || `#${device.id}`;

    return (
      <div id={`device-${device.id}`} className={`${cn} status-${status} device-gui device-gui--tank device-${error}`}>
        <Sound file={Sounds.alarm} play={error}/>
        <DeviceStatusLabel
          name={name}
          status={status}
          title={`#${device.id}`}
          isHorizontal={true}
        />
        <div className="device-icon body"/>
        <div className="device-icon bars"/>
        <div className="device-icon gate"/>
        <div className="device-icon water" style={{height: progress*0.63 + '%'}}/>
        <div className={'device-icon particle'}/>
        <PushButton port={device.gatePNo}
          onPush={() => {
            batchStore.setOutput(device.gatePNo, OUTPUT_TTL);
          }}
        />
        {!!mCode && (
          <div className="device-label">
            <div className="mix" title={mCode}>{mCode}</div>
          </div>
        )}
      </div>
    );
  }
}

export default deviceDOMHoc(Tank);
